import React, { FC } from 'react';

import { Card } from 'app/components/domain/card/card';
import { Typography } from 'app/components/domain/typography';
import { i18n } from 'app/i18n';
import { BillingDetailsInformation } from 'app/components/domain/billing-details/billing-details-information';

import styles from './billing-details.module.scss';

export const BillingDetails: FC = () => (
    <Card>
        <Typography className={styles.title} variant="subtitle3" component="p">
            {i18n.summary.billingDetails.label}
        </Typography>
        <BillingDetailsInformation />
    </Card>
);
